module.exports = __webpack_public_path__ + "static/media/thumb_male_new.ab228233.png";